import React, { useState } from "react"; 
import { Link } from "react-router-dom";
import logo from "../assets/image.png";
import "./header.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">

      {/* ===== TOP BAR ===== */}
      <div className="top-bar">
        <div className="header-top-left-item">
          <span><i className="fa-solid fa-phone"></i></span>
          <a href="tel:+919418094125">+91 9418094125</a>
          <span className="separator">|</span>
          <a href="tel:+917018172074">+91 7018172074</a>
          <span className="separator">|</span>
          <a href="tel:+918580593956">+91 8580593956</a>
          
        </div>
        <div>
          <span><i className="fa-solid fa-envelope"></i></span>
          <a href="mailto:mehartours@gmail.com" style={{color:"#ffff",marginLeft:"5px"}}>mehartours@gmail.com</a>
        </div>
      </div>

      {/* ===== MAIN HEADER ===== */}
      <div className="header-container">

        {/* LOGO */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Mehar Tour And Travels" />
          </Link>
        </div>

        {/* HAMBURGER (Visible Only On Mobile) */}
        <div
          className="hamburger"
          onClick={() => setMenuOpen(true)}
        >
          <i className="fa-solid fa-bars"></i>
        </div>

        {/* NAVIGATION */}
        <nav className={`site-nav ${menuOpen ? "active" : ""}`}>
          {/* CLOSE BUTTON */}
          <div className="close-menu" onClick={() => setMenuOpen(false)}>
            <i className="fa-solid fa-xmark"></i>
          </div>

          <ul>
            <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
            <li><Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link></li>
            <li><Link to="/tours-packages" onClick={() => setMenuOpen(false)}>Tours & Packages</Link></li>
            <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
            <li><Link to="/reviews" onClick={() => setMenuOpen(false)}>Reviews</Link></li>
            <li><Link to="/gallery" onClick={() => setMenuOpen(false)}>Gallery</Link></li>
          </ul>
        </nav>

        {/* CTA (Desktop only) */}
        <div className="header-cta">
          <Link to="/contact" className="btn btn-primary">Enquire Now</Link>
        </div>

      </div>
    </header>
  );
}

export default Header;